import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Typography, Container, Alert } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import parse from "html-react-parser"
import { useTheme } from "@emotion/react";
import { useParams } from "react-router-dom";
import PostBanner from "../posts/PostBanner";
import ImageBGSection from "../reusable/fieldGroups/ImageBGSection";
import MorePosts from "../posts/MorePosts";
import Newsletter from "../reusable/Newsletter";
import { Box } from "@mui/system";

export default function PreviewPost({ post_id, preview_id }) {

	const theme = useTheme();
	const [post, setPost] = useState();

	//if draft preview post
	const { data: preview } = useQuery({
		queryKey: ['page', post_id],
		queryFn: () => axios.get(`${WP_API_Settings.endpoint}wp/v2/posts/${post_id}?_embed&preview=true`, {
			headers: {
				'X-WP-Nonce': WP_API_Settings.nonce
			}
		}),
		retry: 1,
		enabled: !!post_id
	})

	//if revision preview post
	const { data: revision } = useQuery({
		queryKey: ['post', preview_id],
		queryFn: () => axios.get(`${WP_API_Settings.endpoint}wp/v2/posts/${preview_id}/revisions?_embed=true&preview=true`, {
			headers: {
				'X-WP-Nonce': WP_API_Settings.nonce
			}
		}),
		retry: 1,
		enabled: !!preview_id
	})

	//set the page data
	useEffect(() => {
		if (preview?.data) {
			setPost(preview?.data);
		} else if (revision?.data) {
			setPost(revision?.data[0]);
		}
	}, [preview, revision])

	return (
		<>
		<Box
			sx={{
				position: 'fixed',
				width: '100%',
				zIndex: 99999,
				paddingTop: theme.spacing(1),
				paddingBottom: theme.spacing(1),
				paddingLeft: theme.spacing(2),
				paddingRight: theme.spacing(2),
				textAlign: 'center',
				boxSizing: 'border-box'
			}}
		>
			<Alert
			severity="info"
			elevation={3}
			>
				You are currently viewing a preview of this post.
			</Alert>
		</Box>
			<PostBanner
				post={post}
			/>
			<Container maxWidth={theme.global.container} >
				<Grid>

					{/* <Typography variant='h1' component='h1'>
						{post?.title.rendered}
					</Typography> */}
					<article id={`preview-${preview_id || post?.id}`} class={`content-preview`}>
						{post?.content?.rendered ? parse(post?.content?.rendered) : null}
					</article>

				</Grid>
			</Container>
			<ImageBGSection
                content={post?.acf.image_background}
            />
            <MorePosts
                currentPost={post?.id}
            />
            <Newsletter />
		</>

	)
}